import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';

export const wordleViewStyles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    marginTop: 6,
    marginBottom: 2,
  },
  title: {
    fontSize: 17,
    fontWeight: '800',
    color: WARMUP_COLORS.text,
  },
  rewardPill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    backgroundColor: WARMUP_COLORS.amberSurface,
    borderWidth: 1,
    borderColor: WARMUP_COLORS.amberBorder,
    borderRadius: 9999,
    paddingVertical: 3,
    paddingHorizontal: 9,
  },
  rewardPillText: {
    fontSize: 11,
    fontWeight: '700',
    color: WARMUP_COLORS.amber,
  },
  boardArea: {
    flex: 1,
    paddingHorizontal: 16,
    // Guards the brief first-paint frame before the board measures its height: clip any overshoot
    // rather than letting oversized rows bleed up over the title/reward pill.
    overflow: 'hidden',
  },
});
